import { observable, action } from 'mobx'
import * as THREE from 'three'

export const handleDraw = draw$ => {
    draw$.subscribe(position.setTick)
}

export const setCam = cam => {
    position.setCam(cam)
}

const position = observable(
    {
        tick: 0,
        camera: null,
        setTick() {
            this.tick = !this.tick
        },
        setCam(cam) {
            this.camera = cam
        },
        projectToCam(v) {
            return this.camera ? new THREE.Vector3(v.x, v.y, v.z).project(this.camera) : v
        },
    },
    {
        setTick: action.bound,
        setCam: action.bound,
        projectToCam: action.bound,
    }
)

export default position
